// extracted by mini-css-extract-plugin
export default {"cell":"NormalCell_cell__e-dQ6"};